<template>
  <Form
    ref="queryForm"
    class="form-flex label-hide opacity"
    label-position="left"
    :label-width="80"
    :model="queryModel"
    :rules="rules"
    @submit.native.prevent
  >   
  <h2>寵物險</h2>
    <GroupRadio     
      v-model="queryModel.typeOfPet"
      type="button"      
      label="寵物類型"
      :radios="radios"
    />  
    <DateVueSelect
        v-model="queryModel.dateOfBirthPet"
        label="寵物生日"
        prop="dateOfBirthPet"       
        :label-width="83"               
      />
    <!--<DatePickerInput v-model="queryModel.dateOfBirthPet" placeholder=" 年 / 月/ 日" label="寵物生日" prop="dateOfBirthPet" />   
    <BaseVueSelect
      v-model="queryModel.expectPremium"
      label="期望保費"
      prop="expectPremium"
      :options="options"
    />  -->  
    
    <div class="form-footer clearfix mb-s"> 
      <Button
        class="pull-right btn-primary btn-m btn-shadow"
        :loading="loading"
        @click="handleSubmit"
      >
        <span v-if="!loading">快速試算保費</span>
        <span v-else>請稍候</span>
      </Button>
    </div>
    <div class="notice">      
      <p>* 適合寵物為貓、犬。</p> 
      <p>* 被保險寵物年齡需滿8週以上。</p>
      <p>* 實際承保範圍以所投保方案之保險條款為準。</p>         
    </div>
  </Form>
</template>

<script>
//import axios, { generateAuthPostConf  } from '@/utils/axios';
// date-fns
//import differenceInCalendarDays from "date-fns/difference_in_calendar_days";
//import differenceInHours from "date-fns/difference_in_hours";
import getTime from "date-fns/get_time";
// component
import { Form, Button } from "iview";
import GroupRadio from "@/components/forms/elements/GroupRadio";
import DateVueSelect from '@/components/forms/elements/DateVueSelect';
//import DateTimePickerInput from "@/components/forms/elements/DateTimePickerInput";
//import DatePickerInput from "@/components/forms/elements/DatePickerInput";
import BaseVueSelect from "@/components/forms/elements/BaseVueSelect";
// options & radios
import { pettype } from "@/staticData/radios";
// default model
import {
  petModel,
  petRules,
  options,  
} from "@/utils/asyncValidator/queryForms";
//import Cookies from 'js-cookie';
export default {
  components: {
    Form,
    Button,
    GroupRadio,
    DateVueSelect,    
    //DatePickerInput,
    BaseVueSelect
  },
  props: {
    model: {
      type: Object,
      default: () => petModel
    },   
    loading: {
      type: Boolean,
      default: false
    },
    handleQuery: {
      type: Function,
      default: () => {}
    }
  },
  data() {    
    const rules = {
      ...petRules,      
      //dateOfBirthPet: { validator: startTimeValidator , trigger: "validate" }
    };
    const queryModel = this.$cloneDeep(this.model);
 
    return {
      queryModel,  
      options: options.expectPremium.pet,
      rules,
      radios: pettype
    };
  },
  watch: {
    "queryModel.dateOfBirthPet"() {
      const {
        queryModel: { dateOfBirthPet }
      } = this;  
    }
  },
  computed: {
    isEmpty() {
      const { startTime } = this.queryModel;
      return {
        start: Object.values(startTime).some(val => !val),
        //end: Object.values(endTime).some(val => !val)
      };
    },
    /*totalDays() {
      const {
        isEmpty,
        queryModel: { startTime, endTime }
      } = this;
      const isSelectBoth = Object.values(isEmpty).every(val => val === false);
      if (!isSelectBoth) return null;
      const day = differenceInCalendarDays(endTime.date, startTime.date);
      return endTime.time > startTime.time ? day + 1 : day;
    },*/
    premiumLabel() {
      const {
        queryModel: { expectPremium },
        options
      } = this;
      if (!expectPremium) return null;
      const { label } = options.find(option => option.value === expectPremium);
      //console.log("expectPremium:" +expectPremium);
      return label;
    },/*
    disabledHours() {
      const {
        queryModel: { endTime, startTime },
        isEmpty
      } = this;
      if (isEmpty.start) return [];
      const diffDays = differenceInCalendarDays(endTime.date, startTime.date);
      if (diffDays !== 1) return [];
      const [hours] = startTime.time.split(":");
      return Array.from({ length: parseInt(hours, 10) }, (x, i) => i);
    }*/
  },
  methods: {
    validate() {
      return this.$refs.queryForm.validate(v => v);
    },
    async handleSubmit() {
      const isValid = await this.validate();      
      if (!isValid) return;
      const { queryModel, premiumLabel } = this;
      const type = "pet";
      const tips = {  premiumLabel };
      this.handleQuery({ type, tips, ...queryModel });
    }    
  }
};
</script>
